import React  , { Component } from 'react'
import { withRouter } from 'react-router-dom'
import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import {  shuffle } from '../../Utility/Utility'
import { newPosts, TouristInfoPosts } from '../../Data/Data'
import {  Img,
          HomeTitle,
          ResponsiveYouTubeIframe,
          HomeDeals,
          PostSliderItem,
          VideoSliderItem } from '../../Components/UI/UI'

import "../Posts.css"
import "./Posts.css"
import { newPostdata } from "../PostsData"
class Posts extends Component {
  state = {
    id:this.props.match.params.vidId,
    ctgId: this.props.match.params.ctgId

  } 


  componentWillMount() {
  
    // console.log(this.props.match.params)
  }

  componentDidMount (){
 

  }

  componentWillReceiveProps(nextProps) {
   
  }



  render(){

    let counter = 0 ;
    let videosHtml = null;
    let mixVideos = [ ...newPostdata ];

    let limitRelatedPost = 3;

    
    // alert(this.props.match.params.id);
    if ( this.props.match.params.id === "34" ) {
        limitRelatedPost = 2;
    }
    const shuffleData = shuffle(mixVideos);

    const current = newPostdata.find(( o ) => {
      if ( this.props.match.params.ctgId != undefined ) { 
        if ( o.hasOwnProperty("ctg") ) { 
           // console.log('o' , o);
         return ( o.id == this.props.match.params.id && o.ctg == this.props.match.params.ctgId ) ;
       }
      } else {
        return ( o.id === this.props.match.params.id );
      }
      
    });

  // console.log("current" , current);
    if ( this.props.match.params.ctgId != undefined ) { 
       videosHtml = shuffleData.map((o,i) => {
        if ( o.hasOwnProperty("ctg") ) {             

            // if (  o.ctg === this.props.match.params.ctgId  && parseInt(o.id) !== parseInt(this.props.match.params.id) ) {
            if ( o.ctg === this.props.match.params.ctgId ) {

              const postFromPostData = newPosts.find((obj, index)=>{
                
                return obj.id === o.id &&  obj.ctg === o.ctg;
              })
              console.log('postFromPostData' , postFromPostData);
              if ( postFromPostData != undefined  && postFromPostData.id !== current.id){

                counter++
                if ( counter <= limitRelatedPost ) {
                  let component = null;
                  let  url = "/Posts/Videos/" + o.ctg + "/" + o.id ;

                  if  ( o.isVid === true ) {

                    component  =  <VideoSliderItem  
                                    key={i}
                                    title={postFromPostData.title}
                                    desc={postFromPostData.sml_desc}
                                    img= {postFromPostData.img}
                                    link={url} />
                    
                  }else {

                    url = "/Posts/" + o.ctg + "/" + o.id ;
                    component  = <PostSliderItem  
                                    key={i}
                                    title={postFromPostData.title}
                                    desc={postFromPostData.sml_desc}
                                    img= {postFromPostData.img}
                                    link={url}  />
                  }

                  return component;
                
              }
              }
              
            }  else if (o.ctg === 'culinary' || o.ctg === 'culinaryjerusalem' || o.ctg === 'culinarytelaviv'  || o.ctg === 'culinarynorth') {

              // alert('o.ctg:', o.ctg);

              const postFromPostData = newPosts.find((obj, index)=>{
                
                return obj.id === o.id &&  obj.ctg === o.ctg;
              })
                

              console.log('postFromPostData' , postFromPostData);
              if ( postFromPostData != undefined   && postFromPostData.id !== current.id){

              
                counter++
                if ( counter <= 3) {
                  let component = null;
                  let  url = "/Posts/Videos/" + o.ctg + "/" + o.id ;

                  if  ( o.isVid === true ) {

                    component  =  <VideoSliderItem  
                                    key={i}
                                    title={postFromPostData.title}
                                    desc={postFromPostData.sml_desc}
                                    img= {postFromPostData.side_img}
                                    link={url} />
                    
                  }else {


                    url = "/Posts/" + o.ctg + "/" + o.id ;
                    component  = <PostSliderItem  
                                    key={i}
                                    title={postFromPostData.title}
                                    desc={postFromPostData.sml_desc}
                                    img= {postFromPostData.side_img}
                                    link={url}  />
                  }

                  return component;
                
              }
              }

            }

            



            if ( o.ctg === this.props.match.params.ctgId ) {

              const postFromTouristData = TouristInfoPosts.find((obj, index)=>{
                
                return obj.id === o.id &&  obj.ctg === o.ctg;
              })
              console.log('postFromTouristData' , postFromTouristData);
              if ( postFromTouristData != undefined ){

                counter++
                if ( counter <= limitRelatedPost ) {
                  let component = null;
                  let  url = "/Posts/Videos/" + o.ctg + "/" + o.id ;

                  if  ( o.isVid === true ) {

                    component  =  <VideoSliderItem  
                                    key={i}
                                    title={postFromTouristData.title}
                                    desc={postFromTouristData.sml_desc}
                                    img= {postFromTouristData.img}
                                    link={url} />
                    
                  }else {

                    url = "/Posts/" + o.ctg + "/" + o.id ;
                    component  = <PostSliderItem  
                                    key={i}
                                    title={postFromTouristData.title}
                                    desc={postFromTouristData.sml_desc}
                                    img= {postFromTouristData.img}
                                    link={url}  />
                  }

                  return component;
                
              }
              }
              
            }
        }
      });
      

    }
   
  

    let html = null;
    let smlTitle = null;
    let title = null;
    if ( current != undefined ){
      console.log('success');
        let vidHTML = null

       if ( current.isVid === true ) {
        vidHTML  =  <ResponsiveYouTubeIframe vidId={current.vidId} />
       }
      const title = current.title;
       let smltitle = current.hasOwnProperty("smltitle") ?  current.smltitle : current.smlTitle  ;

       let titleHTML  = null;
       let smlTitleHTML  = null;
       if ( smltitle !== '' ) {

        titleHTML  =  <h1 className="page-section-big-title">
                 {title}
                </h1>;
        smlTitleHTML  = <HomeTitle>
                    {smltitle}
                  </HomeTitle>;
       }else {
          titleHTML  =  <h1 className="page-section-big-title">
        
          </h1>;
          smlTitleHTML  = <HomeTitle>
            {title}
          </HomeTitle>;
       }


      // client custom req
      console.log('this.state' , this.state);

      // if ( current.id === 5 ) {
      //   titleHTML = '';
      // }


      html = <div className={'inner-post post post-type-videos post-type-posts inner-post-' + current.id }>
        <Menu />
        <section className="post-data">
           <div className="main-post-banner">
             <Img desktopImg={current.bgImage} 
                  mobileImg={current.mobBgImage} />
              <div className="container align-center white">
                {titleHTML}
              </div>
            </div>
            <div className="container content-container">
              <div className="col col-75">
                <div className="inner">
                  {smlTitleHTML}
                  <div className="clear"></div>
                  {vidHTML}
                  <div className="clear"></div>
                  <div className="html-wrapper" dangerouslySetInnerHTML={current.html()} ></div>
                  <div className="clear"></div>
                  <HomeDeals />
                </div>
              </div>
              <div className="col col-25 sidebar">
                <div className="inner">
                  <HomeTitle>
                  ÄHNLICHE POSTS
                  </HomeTitle>
                  {videosHtml}
                  
                </div>
              </div>
              <div className="clear"></div>
            </div>
        </section>
        <Footer />
      </div>
    }
 
    return(html)
  }

}



export default withRouter(Posts)


// WEBPACK FOOTER //
// ./src/Posts/Posts/Posts.js